import TripDetail from "./TripDetail";

export default TripDetail;
